import React from 'react'
import { Flex, Typography } from 'antd'
import { Icon } from '@/shared/ui/Icon/Icon'
import { DarkButton, PrimaryButton } from '@/shared/ui/components/Button'
import { MediumInput } from '@/shared/ui/components/Input'
import { useBreakpoint } from '@/app/hooks/useBreakpoint'
import { ServerModalStyled } from './styled'

const { Text } = Typography

interface ServerModalProps {
  title: string
  open: boolean
  selectedServer: string
  onSave: () => void
  onCancel: () => void
  onChange: (value: string) => void
  onResetToDefault: () => void
  placeholder?: string
  description?: string
}

export const ServerModal: React.FC<ServerModalProps> = ({
  title,
  open,
  selectedServer,
  onSave,
  onCancel,
  onChange,
  onResetToDefault,
  placeholder = 'Введите адрес сервера',
  description,
}) => {
  const { isSm, isXs } = useBreakpoint()
  const isMobile = isXs || isSm

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  return (
    <ServerModalStyled
      title={title}
      open={open}
      onOk={onSave}
      onCancel={onCancel}
      closeIcon={
        <Icon
          name={isMobile ? 'closed_modal_phone' : 'closed_modal'}
          size={16}
        />
      }
      footer={[
        <DarkButton size="small" key="default" onClick={onResetToDefault}>
          По умолчанию
        </DarkButton>,
        <PrimaryButton size="small" key="submit" onClick={onSave}>
          Сохранить
        </PrimaryButton>,
      ]}
      width={650}
      centered
    >
      <Flex vertical gap={24}>
        <Flex vertical gap={4}>
          <Text strong>Адрес сервера</Text>
          <MediumInput
            value={selectedServer}
            onChange={handleInputChange}
            placeholder={placeholder}
          />
          {description && (
            <Text
              type="secondary"
              style={{ fontSize: '12px', marginTop: '4px' }}
            >
              {description}
            </Text>
          )}
        </Flex>
      </Flex>
    </ServerModalStyled>
  )
}
